export default __webpack_public_path__ + "static/integtestworkflow-33f31a3b16737051f59ce0ae38d84016.png";